export default function Projects(){
    return(
        <div className = "Page"> 
            <h1>Achievements</h1>
            <h2>Competition Math Experience</h2>
            <p>
                I have done competitive math for over seven years. I am a two-time national Mathcounts qualifier (6th and 8th grade, as 7th grade Mathcounts was 
                canceled due to COVID-19). I am also a two-time USAJMO qualifier, three-time USAMO qualifier and an AIME qualifier since 6th grade. I have also achieved DHR (top 1%)
                for the AMC 10.

                In 2022, 2023, and 2024 I qualified for the Math Olympiad Program (MOP) and qualified for the Team Selection Test group.
            </p>
            <h2>Research Math Experience</h2>
            <p>
                I qualified for the PRIMES-USA research program in 2023 and 2024. In 2023, two other students and I published a paper on Abstract Algebra <a href="https://arxiv.org/abs/2307.09645">here</a>.
            </p>
            <h2>Programming Experience</h2>
            <p>
                I have done competitive programming for about two years. I am a specialist on <a href="https://codeforces.com/profile/JiangSTEM">Codeforces</a>, and 
                also have an account on <a href="https://leetcode.com/HenrySTEM/">LeetCode</a>. I am currently in the gold division of USACO.
            </p>

            <h2>Miscellaneous Achivements</h2>
            <p>
                National Mythology Exam - Silver <br/>
                National Latin Exam - Magna Cum Laude <br/>
                American Guild of Music Regional (Piano) - Multiple first, second, and third place awards across 5 years (Length of Study, Age Group, Pop) <br/>
                Quiz bowl! HSNCT 2024 top 3% individual
            </p>       
            <h1>Projects</h1>
            <p> 
                Currently, there are not many important projects I have done. They will appear here once I do them (and I plan to do one pretty soon).
            </p>
        </div>

    )
}
